import { iRequest } from '@/utils/requestutil';

export async function save(payload) {
  return iRequest(`/iwms-openapi/api/datasource`, {
    method: 'POST',
    body: payload,
  });
}

export async function query(payload) {
  return iRequest(
    `/iwms-openapi/api/datasource/query?companyUuid=${payload.companyUuid}&name=${payload.name}`,
  );
}

export async function modify(payload) {
  return iRequest(`/iwms-openapi/api/datasource/modify`, {
    method: 'POST',
    body: payload,
  });
}

export async function remove(payload) {
  return iRequest(`/iwms-openapi/api/datasource/remove?uuid=${payload.uuid}`, {
    method: 'POST',
  });
}

export async function get(payload) {
  return iRequest(`/iwms-openapi/api/datasource/${payload.uuid}`);
}
